<script lang="ts" setup>
import InnerReload from '@/components/InnerReload.vue';

const reloadPage = () => document.location.reload();
</script>

<template>
  <section class="packages-error">
    <InnerReload
      class="packages-error__reload"
      @action="reloadPage"
    />

    <ul class="packages-error__packages container">
      <li
        v-for="pack in 3"
        :key="pack"
        class="packages-error__package"
      ></li>
    </ul>
  </section>
</template>

<style lang="scss" scoped>
.packages-error {
  $this: 'packages-error';

  padding-top: 36px;
  padding-bottom: 36px;
  background-color: $color-secondary-200;
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  &__packages {
    list-style-type: none;
    margin-block: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    opacity: 0.4;
  }

  &__package {
    $this: 'package';
    $shadow-card: 0px 16px 48px -16px rgb(78 75 102 / 16%);
    $shadow-border: inset 0px 0px 0px 1px $color-dark-blue-200;

    background-color: $color-white;
    box-shadow: $shadow-card, $shadow-border;
    border-radius: $brd-8;

    &:nth-child(1),
    &:nth-child(3) {
      width: 30%;
      aspect-ratio: 1 / 0.8;
    }

    &:nth-child(2) {
      width: 30%;
      aspect-ratio: 1 / 1;
    }
  }
}
</style>
